<template>
  <div v-if="!showForgotPassword">
    <div v-if="whitelabel.brand == 'oldmutual'" class="login-container">
      <div class="login-content">
        <div class="title-section">
          <h1>Log in</h1>
          <p v-if="tebaMode">Use your industry number to continue</p>
          <p v-else>Use your email or other service to continue</p>
        </div>
        <div class="error-section">
          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
        </div>
        <div v-if="tebaMode" class="email-section">
          <SignInWithNumber
            @onError="onError"
            @forgotPassword="forgotPassword"
          />
        </div>
        <template v-else>
          <div class="sso-section">
            <GoogleSsoSignIn @onError="onError"></GoogleSsoSignIn>
          </div>
          <div class="or-hr-section">
            <OrHr />
          </div>
          <div class="email-section">
            <SignInWithEmail
              @forgotPassword="forgotPassword"
              @onError="onError"
            ></SignInWithEmail>
          </div>
        </template>
        <AlreadyHaveAnAccount :type="'login'" @signupClicked="signupClicked" />
      </div>
    </div>
    <div v-else-if="whitelabel.brand == 'teba'" class="login-container">
      <div class="login-content">
        <div class="title-section">
          <h1>Log in</h1>
          <p>Use your industry number to continue</p>
        </div>
        <div class="error-section">
          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
        </div>
        <div class="email-section">
          <SignInWithNumber
            @onError="onError"
            @forgotPassword="forgotPassword"
          />
        </div>
        <AlreadyHaveAnAccount :type="'login'" @signupClicked="signupClicked" />
      </div>
    </div>
  </div>
  <div v-else>
    <div
      v-if="whitelabel.brand == 'oldmutual'"
      class="login-container forgot-password"
    >
      <div class="login-content">
        <div class="title-section">
          <h1>Forgot password</h1>
          <p>{{ whitelabel.authentication.resetPassword.title }}</p>
        </div>
        <div class="error-section">
          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
        </div>
        <div class="email-section">
          <ForgotPasswordEmail @successResetPassword="successResetPassword" />
        </div>
      </div>
    </div>
    <div v-else-if="whitelabel.brand == 'teba'" class="login-container">
      <div class="login-content">
        <div class="title-section">
          <h1>Forgot password</h1>
          <p>{{ this.whitelabel.authentication.resetPassword.title }}</p>
        </div>
        <div class="error-section">
          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
        </div>
        <div class="email-section">
          <ForgotPasswordEmail @successResetPassword="successResetPassword" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import GoogleSsoSignIn from '../GoogleSsoSignIn.vue';
  import SignInWithEmail from '../SignInWithEmail.vue';
  import ForgotPasswordEmail from '../ForgotPasswordEmail.vue';
  import SignInWithNumber from '../SignInWithNumber.vue';
  import OrHr from '../../common/OrHr.vue';
  import AlreadyHaveAnAccount from '../AlreadyHaveAnAccount.vue';
  import { isTebaMode } from '../../../utils/tebaMode';

  export default {
    name: 'Login',
    components: {
      GoogleSsoSignIn,
      SignInWithEmail,
      SignInWithNumber,
      ForgotPasswordEmail,
      OrHr,
      AlreadyHaveAnAccount,
    },
    data() {
      return {
        acceptedTerms: true,
        errorMessage: '',
        showForgotPassword: false,
      };
    },
    computed: {
      tebaMode() {
        return isTebaMode();
      },
    },
    methods: {
      successResetPassword() {
        this.$emit('successResetPassword');
      },
      signupClicked() {
        this.$emit('signupClicked');
      },
      forgotPassword() {
        this.showForgotPassword = true;
      },
      onError(error) {
        if (error) {
          if (error.message.includes('GraphQL error:')) {
            this.errorMessage = error.message
              .replace('GraphQL error:', '')
              .trim();
          } else {
            this.errorMessage =
              "Something went wrong, we're looking into it. Please try login again.";
            throw error;
          }
        } else {
          this.errorMessage = '';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .login-container {
    display: flex;
    justify-content: center;
    padding: 0 30px;
    min-height: 50dvh;
    &.forgot-password {
      flex-direction: column;
      align-items: center;
    }
    .login-content {
      width: clamp(360px, 22dvw, 400px);
      padding-top: 155px;
    }

    .title-section {
      h1 {
        font-size: 22px;
        font-weight: 500;
        line-height: 30px;
        margin-bottom: 10px;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        line-height: 18.2px;
        margin: 0;
      }
    }
    .sso-section {
      margin-top: 22px;
    }
    .or-hr-section {
      margin-top: 16px;
      margin-bottom: 16px;
    }

    .error-section {
      p {
        margin: 0;
        margin-top: 16px;
        margin-bottom: 16px;
      }
    }
  }
</style>
